import { useEffect } from 'react';
import { Box } from '@chakra-ui/react';

import Alert from 'UiKit/alert';

import Filter from 'View/user/section/filter';
import Head from 'View/user/section/head';
import Table from 'View/user/section/table';
import UserProvider, { useUserState } from 'View/user/state';
import useResetAllState from 'View/user/hooks/useResetAllState';

import styles from './styles.module.css';

const User = () => {
  const { state } = useUserState();
  const onResetAllState = useResetAllState();

  useEffect(() => onResetAllState(), /* eslint-disable */ []);

  return (
    <Box className={styles['user__container']} data-testid="user__container">
      <Head />
      <Filter />
      <Alert {...state?.alertProps} />
      <Table />
    </Box>
  );
};

const UserContainer = () => <UserProvider children={<User />} />;

export default UserContainer;
